<template>
    <v-form>
        <v-text-field
                outlined
                ref="name"
                v-model="$v.documentGroup.name.$model"
                label="Document Group Name"
                :error-messages="documentGroupNameErrors"
                error-count=2
                hint="ie. Analyst, Assistant, Supervisor"
                required>
        </v-text-field>
        <br>
        <v-layout>
            <v-flex xs12 sm10 md8 lg6 style="text-align: left">
                Apply to User type:
            </v-flex>
        </v-layout>
        <v-layout >
            <v-flex xs12 sm10 md8 lg6>
                <v-switch label="Employee"
                          :error-messages="userTypeError"
                          v-model="$v.employeeType.$model">
                </v-switch>
            </v-flex>
            <v-flex xs12 sm10 md8 lg6>
                <v-switch label="Client"
                          :error-messages="userTypeError"
                          v-model="$v.clientType.$model">
                </v-switch>
            </v-flex>
        </v-layout>

        <v-divider class="mt-5"></v-divider>

        <v-btn  color="primary"
                @click="stpper1Continue">
            Continue
        </v-btn>

        <v-btn text @click="close">
            Cancel
        </v-btn>
    </v-form>
</template>

<script>
    import { required, minLength} from 'vuelidate/lib/validators';
    import {USER_TYPE} from '../../../shared/enums/UserType';
    import {DocumentGroup} from '../../../shared/dtos/Dtos';

    export default {
        name: "documentGroupDefine",
        data(){
            return{
                documentGroup: {
                    ...DocumentGroup
                },
                employeeType: false,
                clientType: false
            }
        },
        validations: {
            documentGroup:{
                name: {
                    required,
                    minLength: minLength(5)
                }
            },
            employeeType:{
                required: function() { return this.clientType || this.employeeType }
            },
            clientType:{
                required: function()  {return this.clientType || this.employeeType}
            }
        },
        computed: {
            documentGroupNameErrors(){
                const errors = []
                if (!this.$v.documentGroup.name.$dirty) {
                    return errors
                }

                !this.$v.documentGroup.name.minLength && errors.push('Name must be at least '+
                    this.$v.documentGroup.name.$params.minLength.min +' characters long')
                !this.$v.documentGroup.name.required && errors.push('Name is required.')
                return errors
            },
            userTypeError(){
                const errors = []
                if(!this.$v.employeeType.$dirty && !this.$v.clientType.$dirty){
                    return errors
                }

                !this.$v.employeeType.required && errors.push('Employee, Client or both need to be selected')
                !this.$v.clientType.required && errors.push('Employee, Client or both need to be selected')
                return errors
            }
        },
        methods: {
            stpper1Continue(){
                this.$v.$touch()

                if(this.$v.$anyError){
                    return;
                }

                if(this.employeeType){
                    this.documentGroup.type = USER_TYPE.EMPLOYEE;
                }
                else{
                    this.documentGroup.type = USER_TYPE.CLIENT;
                }

                this.$store.commit('setDocumentGroup', this.documentGroup)
                this.$emit('stepper', 2)
            },
            close(){
                this.$emit('closeStepper', false)
            }
        }
    }
</script>

<style scoped>

</style>